import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function CTASection() {
  return <section id="offer" className="py-16 md:py-24 bg-gradient-to-br from-emerald-900 to-slate-900 text-white" data-id="element-22">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-23">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-24">
          Recupera tu independencia hoy mismo
        </h2>
        <p className="text-xl text-emerald-100 mb-12 max-w-2xl mx-auto" data-id="element-25">
          Tus hijos te necesitan fuerte. Tus nietos quieren correr contigo. Y tú
          mereces vivir tus mejores años sin dolor.
        </p>

        <div className="bg-white text-slate-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto relative overflow-hidden" data-id="element-26">
          {/* Discount Badge */}
          <div className="absolute top-0 right-0 bg-red-500 text-white font-bold px-6 py-2 rounded-bl-2xl text-lg" data-id="element-27">
            OFERTA ESPECIAL
          </div>

          <div className="mb-8" data-id="element-28">
            <p className="text-slate-500 text-lg mb-2" data-id="element-29">
              Precio Regular:{' '}
              <span className="line-through decoration-red-500 decoration-2" data-id="element-30">
                $47 USD
              </span>
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-31">
              <span className="text-6xl md:text-7xl font-black text-emerald-700" data-id="element-32">
                $6.39
              </span>
              <span className="text-xl text-slate-600 font-bold self-end mb-4" data-id="element-33">
                USD
              </span>
            </div>
            <p className="text-emerald-600 font-bold mt-2" data-id="element-34">
              Pago único. Acceso de por vida.
            </p>
          </div>

          <Button size="xl" fullWidth withIcon href="https://www.viventispace.com/cart/45947227177148:1" className="mb-6 shadow-amber-500/50 shadow-lg animate-pulse" data-id="element-35">
            DESCARGAR AHORA
          </Button>

          <div className="flex flex-col gap-4 text-sm text-slate-500 bg-slate-50 p-4 rounded-xl" data-id="element-36">
            <div className="flex items-center justify-center gap-2" data-id="element-37">
              <Lock className="h-4 w-4" data-id="element-38" />
              <span data-id="element-39">Pago 100% Seguro y Encriptado</span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-40">
              <CreditCard className="h-4 w-4" data-id="element-41" />
              <span data-id="element-42">Aceptamos todas las tarjetas</span>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center gap-4" data-id="element-43">
          <ShieldCheck className="h-16 w-16 text-emerald-400" data-id="element-44" />
          <h3 className="text-2xl font-bold" data-id="element-45">Garantía de Hierro de 30 Días</h3>
          <p className="text-emerald-100 max-w-xl" data-id="element-46">
            Si en 30 días no sientes tus rodillas más fuertes y con menos dolor,
            te devolvemos el 100% de tu dinero. Sin preguntas. Te quedas con la
            guía gratis.
          </p>
        </div>
      </div>
    </section>;
}